(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wfp-email-signup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wfp-email-signup')) {
    class WFPEmailSignup extends HTMLElement {
      connectedCallback() {
        this.formId = (this.dataset.formId || '').trim();
        if (!this.formId) return;

        this.formRoot = this.querySelector('.wfp-email-signup__klaviyo');
        this.statusRoot = this.querySelector('[data-wfp-status]');
        this.statusTitle = this.querySelector('[data-wfp-status-title]');
        this.statusText = this.querySelector('[data-wfp-status-text]');
        this.copyHeading = this.querySelector('[data-wfp-copy-heading]');
        this.copyText = this.querySelector('[data-wfp-copy-text]');

        this.defaultHeading = this.copyHeading?.textContent?.trim() || 'JOIN THE LIST';
        this.defaultTextHTML = this.copyText?.innerHTML || '';
        this.storageKey = `wfp-email-signup:${this.formId}:subscribed`;
        this.state = 'loading';

        this.removeAttribute('data-wfp-signup-ready');

        this.onFormEvent = this.handleFormEvent.bind(this);
        this.onFormClick = this.handleFormClick.bind(this);
        window.addEventListener('klaviyoForms', this.onFormEvent);
        this.addEventListener('click', this.onFormClick, true);

        // A successful signup is remembered on this browser so future visits
        // show confirmation instead of an empty Klaviyo embed.
        if (this.wasSubscribed()) {
          this.showSubscribedState();
          return;
        }

        if (this.formRoot) {
          this.formObserver = new MutationObserver(() => this.checkFormState());
          this.formObserver.observe(this.formRoot, { childList: true, subtree: true, attributes: true });
          this.checkFormState();
          this.formCheckTimer = window.setTimeout(() => this.checkFormState(true), 2500);
        }
      }

      disconnectedCallback() {
        window.removeEventListener('klaviyoForms', this.onFormEvent);
        this.removeEventListener('click', this.onFormClick, true);
        this.formObserver?.disconnect();
        window.clearTimeout(this.formCheckTimer);
      }

      wasSubscribed() {
        try {
          return window.localStorage.getItem(this.storageKey) === '1';
        } catch (error) {
          return false;
        }
      }

      rememberSubscribed() {
        try {
          window.localStorage.setItem(this.storageKey, '1');
        } catch (error) {}
      }

      checkFormState(finalCheck = false) {
        if (!this.formRoot || this.state === 'subscribed' || this.state === 'declined') return;

        const interactive = this.formRoot.querySelector(
          'form, input, select, textarea, button, [role="button"]'
        );
        const hasContent = this.formRoot.textContent.trim().length > 0;

        if (interactive || hasContent) {
          this.showSignupState();
          return;
        }

        if (finalCheck) {
          // Klaviyo commonly suppresses an embed after a completed signup.
          // Keep the section visible and turn it into a confirmation state.
          if (this.dataset.designMode === 'true') {
            this.showSignupState();
          } else {
            this.showSubscribedState();
          }
        }
      }

      normalizeLabel(value) {
        return String(value || '')
          .toLowerCase()
          .replace(/[.,!]/g, '')
          .replace(/\s+/g, ' ')
          .trim();
      }

      handleFormEvent(event) {
        const detail = event.detail || {};
        const eventFormId = String(detail.formId || detail.formID || '');
        if (eventFormId !== this.formId) return;

        if (detail.type === 'submit') {
          this.rememberSubscribed();
          this.showSubscribedState();
          return;
        }

        if (detail.type === 'close' && this.state !== 'subscribed') {
          this.showDeclinedState();
          return;
        }

        if (this.state === 'loading') this.showSignupState();
      }

      handleFormClick(event) {
        const target = event.target instanceof Element ? event.target : null;
        const control = target?.closest('button, a, [role="button"], input[type="button"], input[type="submit"]');
        const formWrap = control?.closest('.wfp-email-signup__klaviyo');
        if (!formWrap || !this.contains(formWrap)) return;

        const expected = this.normalizeLabel(this.dataset.dismissLabel || 'No, thanks');
        const labels = [control.textContent, control.getAttribute('aria-label'), control.value];
        const isDecline = expected && labels.some((label) => this.normalizeLabel(label) === expected);
        if (!isDecline) return;

        // "No, thanks" is intentionally page-session-only. Prevent Klaviyo from
        // permanently suppressing this embedded signup for that visitor.
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        this.showDeclinedState();
      }

      showSignupState() {
        this.state = 'signup';
        this.setAttribute('data-wfp-signup-ready', '');
        if (this.formRoot) this.formRoot.hidden = false;
        if (this.statusRoot) this.statusRoot.hidden = true;
        if (this.copyHeading) this.copyHeading.textContent = this.defaultHeading;
        if (this.copyText) this.copyText.innerHTML = this.defaultTextHTML;
      }

      showSubscribedState() {
        this.state = 'subscribed';
        this.setAttribute('data-wfp-signup-ready', '');
        if (this.formRoot) this.formRoot.hidden = true;
        if (this.statusRoot) this.statusRoot.hidden = false;
        if (this.copyHeading) this.copyHeading.textContent = 'THANKS FOR JOINING';
        if (this.copyText) this.copyText.innerHTML = '<p>You’re officially on the list.</p>';
        if (this.statusTitle) this.statusTitle.textContent = this.dataset.subscribedHeading || 'YOU’RE ON THE LIST';
        if (this.statusText) this.statusText.textContent = this.dataset.subscribedText || 'Keep an eye on your inbox for new music, merch, shows, and updates.';
      }

      showDeclinedState() {
        this.state = 'declined';
        this.setAttribute('data-wfp-signup-ready', '');
        if (this.formRoot) this.formRoot.hidden = true;
        if (this.statusRoot) this.statusRoot.hidden = false;
        if (this.copyHeading) this.copyHeading.textContent = 'NO WORRIES';
        if (this.copyText) this.copyText.innerHTML = '<p>You can join the list anytime.</p>';
        if (this.statusTitle) this.statusTitle.textContent = this.dataset.declinedHeading || 'MAYBE NEXT TIME';
        if (this.statusText) this.statusText.textContent = this.dataset.declinedText || 'The signup form will be back the next time you visit or refresh the page.';
      }
    }

    customElements.define('wfp-email-signup', WFPEmailSignup);
  }

  } catch(e) { console.error(e); }
})();
})();
